import MainLayout from "layout/MainLayout";
import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import AlbumLayout from "views/albums/AlbumLayout";

const Album = Loadable(lazy(() => import("views/albums/Album")));
const AlbumContestantsCardsPage = Loadable(
  lazy(() => import("views/albums/contestants-by-cards"))
);
const AlbumTagsPage = Loadable(lazy(() => import("views/albums/tags")));
const ImportContacts = Loadable(
  lazy(() => import("views/albums/contestants/ImportContestants"))
);
const AlbumPhotoImport = Loadable(
  lazy(() => import("views/albums/photos/import/AlbumPhotoImport"))
);
const AlbumPhotoScript = Loadable(
  lazy(() => import("views/albums/photos/script"))
);
const AlbumPhotoPage = Loadable(lazy(() => import("views/albums/photos")));
const AlbumNew = Loadable(lazy(() => import("views/albums/AlbumNewOrEdit")));
const UserSubscriptions = Loadable(
  lazy(() => import("views/albums/user-subscriptions"))
);
const AlbumOrdersPage = Loadable(lazy(() => import("views/albums/orders")));
const AlbumCommunication = Loadable(
  lazy(() => import("views/albums/communication"))
);

const AlbumRoutes = {
  path: "/dashboard/albums",
  element: (
    <AuthGuard>
      <MainLayout layout={<AlbumLayout />} />
    </AuthGuard>
  ),
  children: [
    {
      path: "/dashboard/albums/:id",
      element: <Album />,
    },
    {
      path: "/dashboard/albums/:id/edit",
      element: <AlbumNew isEdition />,
    },
    {
      path: "/dashboard/albums/:id/photos",
      element: <AlbumPhotoPage />,
    },
    {
      path: "/dashboard/albums/:id/photos/import",
      element: <AlbumPhotoImport />,
    },
    {
      path: "/dashboard/albums/:id/photos/script",
      element: <AlbumPhotoScript />,
    },
    {
      path: "/dashboard/albums/:id/contestants-by-cards",
      element: <AlbumContestantsCardsPage />,
    },
    {
      path: "/dashboard/albums/:id/tags",
      element: <AlbumTagsPage />,
    },
    {
      path: "/dashboard/albums/:id/contestants/import",
      element: <ImportContacts />,
    },
    {
      path: "/dashboard/albums/:id/user-subscriptions",
      element: <UserSubscriptions />,
    },
    {
      path: "/dashboard/albums/:id/orders",
      element: <AlbumOrdersPage />,
    },
    {
      path: "/dashboard/albums/:id/marketing/communication",
      element: <AlbumCommunication />,
    },
  ],
};

export default AlbumRoutes;
